export default __webpack_public_path__ + "static/media/Beltsander SHARPMAX.d1e4425c.png";